import { Pipe, PipeTransform } from '@angular/core';
import { LatestTransactionRow } from '@kempoweroyj/ngx-evse-api-client';
import moment from 'moment';
@Pipe({
    name: 'scheduledDepartureTime',
})
export class ScheduledDepartureTimePipe implements PipeTransform {
    transform(tx: LatestTransactionRow, relative = false): string | undefined {
        const now = new Date().toISOString();
        if (
            !tx?.schedulePlan?.plannedDepartureTime ||
            (tx.schedulePlan.plannedDepartureTime && moment(tx.schedulePlan.plannedDepartureTime).isBefore(now))
        ) {
            return undefined;
        }

        if (relative) {
            // relative time
            return moment.duration(moment(tx.schedulePlan.plannedDepartureTime).diff(moment())).humanize(true);
        } else {
            // absolute time
            return moment(tx.schedulePlan.plannedDepartureTime).format('HH:mm');
        }
    }
}
